import React from 'react';
import './App.css';
import { Wrapper } from '../containers/Wrapper';

function App() {
  return (
    <Wrapper />
  );
}

export default App;
